__turbopack_context__.v({
  "button__icon": "back-button-module-scss-module__QLJZLa__button__icon",
});
